import { Navigate } from "react-router-dom";
import { useAuthStore } from "../state/authStore";
import TeamOnboardingGate from "./TeamOnboardingGate";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuthStore();

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <div className="spinner" style={{ width: 32, height: 32 }} />
      </div>
    );
  }

  if (!user) {
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return <TeamOnboardingGate>{children}</TeamOnboardingGate>;
}
